import axios from '@/util/axios'
import debug from '@/util/debug'

const fnm = 'api/data.js'
const URL = process.env.VUE_APP_ROOT_API + '/prpv'

export default {
	dataAtual: () => {
        debug(null, 'dataAtual', fnm)
        return axios.get(`${URL}/api/v1/data/atual-formatada`)
    }
}
